<mat-sidenav-container (backdropClick)="backdropClose()">
  <mat-sidenav  #sidenav
                fixedInViewport disableClose
                fixedTopGap="{{isSmallToolbar ? '56' : '64'}}"
                position="end" mode="over" [ngClass]="{'sidenav-full-width': isSmallToolbar, 'sidenav-half-width': !isSmallToolbar}">
    <app-details-sidenav *ngIf="sidenavData"
                         [type]="sidenavData.newsItem.type"
                         [status]="sidenavData.newsItem.status ? sidenavData.newsItem.status : null"
                         [taskStatus]="sidenavData.newsItem.taskStatus ? sidenavData.newsItem.taskStatus : null"
                         [subject]="sidenavData.newsItem.subject ? sidenavData.newsItem.subject : '[N/A]'"
                         [attachments]="sidenavData.newsItem.attachments ? sidenavData.newsItem.attachments : []"
                         [comments]="sidenavData.newsItem.comments ? sidenavData.newsItem.comments : []"
                         [result]="sidenavData.newsItem.result"
                         [id]="sidenavData.newsItem.id"
                         [referenceNumber]="sidenavData.newsItem.referenceNumber ? sidenavData.newsItem.referenceNumber : '[N/A]'"
                         [taskName]="sidenavData.newsItem.taskName ? sidenavData.newsItem.taskName : '[N/A]'"
                         [possibleResults]="sidenavData.newsItem.possibleResults ? sidenavData.newsItem.possibleResults : []"
                         [taskStart]="sidenavData.newsItem.taskStart ? sidenavData.newsItem.taskStart : '[N/A]'"
                         [wfDescription]="sidenavData.newsItem.wfDescription ? sidenavData.newsItem.wfDescription : ''"
                         [taskDescription]="sidenavData.newsItem.taskDescription ? sidenavData.newsItem.taskDescription : ''"
                         [metaItem]="sidenavData.newsItem.metaItems? sidenavData.newsItem.metaItems : []"
                         [mfTorzsOptionList]="requestData.mfMasterOptionList"
                         [dictionaryOptionList]="requestData.szotarOptionList"
                         [icon]="sidenavData.newsItem.icon"
                         [taskStartUser]="sidenavData.newsItem.creator && sidenavData.newsItem.creator.userName ? sidenavData.newsItem.creator.userName : '[N/A]'"
                         [templateName]="sidenavData.newsItem.templateName && sidenavData.newsItem.templateName.name ? sidenavData.newsItem.templateName.name : '[N/A]'"
                         [tabIndex]="sidenavData.tabNum"
                         [backdropClicked]="sidenavData.backdropClicked || false"
                         [deadline]="sidenavData.newsItem.taskDeadline ? sidenavData.newsItem.taskDeadline : '-'"
                         [taskInternalDeadline]="sidenavData.newsItem.taskMetaItems && sidenavData.newsItem.taskMetaItems.internalDeadline ? sidenavData.newsItem.taskMetaItems.internalDeadline : '-'"
                         [taskPriority]="sidenavData.newsItem.taskMetaItems && sidenavData.newsItem.taskMetaItems.priority ? sidenavData.newsItem.taskMetaItems.priority.name : '-'"
                         [taskPartnerName]="sidenavData.newsItem.taskMetaItems && sidenavData.newsItem.taskMetaItems.partner ? sidenavData.newsItem.taskMetaItems.partner.partnerFullName : '-'"
                         [taskAdditionalExecutors]="sidenavData.newsItem.additionalExecutors ? sidenavData.newsItem.additionalExecutors : []"
                         (closeEvent)="closeDetails($event)" (detailsEvent)="onDetails($event)"></app-details-sidenav>
  </mat-sidenav>
  <mat-sidenav-content style="min-height: 100vh">
    <mat-toolbar *ngIf="isSmallScreen">
      <div style="display: flex; flex-direction: row; column-gap: 8px; align-items: center; justify-content: space-between; width: 100%">
        <button mat-mini-fab [matMenuTriggerFor]="menuNew" #menuTriggerNew="matMenuTrigger"
                [ngClass]="{ 'bottom-radius-0': menuTriggerNew.menuOpen }">
          <mat-icon>add</mat-icon>
        </button>
        <mat-form-field subscriptSizing="dynamic" style="width: 100%" class="compact-form-field">
          <input type="search" matInput placeholder="{{'SEARCH' | translate}}"
                 [(ngModel)]="searchValue"
                 (ngModelChange)="onSearchInput()">
          <mat-icon matIconPrefix class="icon-design">search</mat-icon>
        </mat-form-field>
        <div style="display: flex; flex-direction: row; align-items: center; gap: 8px">
          <button mat-mini-fab [matMenuTriggerFor]="menuSort" #menuTriggerSort="matMenuTrigger"
                  [ngClass]="{ 'bottom-radius-0': menuTriggerSort.menuOpen }">
            <mat-icon>sort</mat-icon>
          </button>
          <button mat-mini-fab [matMenuTriggerFor]="menuFilter" #menuTriggerFilter="matMenuTrigger"
                  [ngClass]="{ 'bottom-radius-0': menuTriggerFilter.menuOpen }">
            <mat-icon>tune</mat-icon>
          </button>
        </div>
      </div>
    </mat-toolbar>

    <mat-toolbar *ngIf="!isSmallScreen" style="gap: 1.325rem; width: 95%; margin: 8px auto">
      <button mat-fab extended="true" [matMenuTriggerFor]="menuNew" #menuTriggerNew="matMenuTrigger"
              [ngClass]="{ 'bottom-radius-0': menuTriggerNew.menuOpen }">
        <mat-icon>add</mat-icon>
        <span>{{'NEW_TASK' | translate}}</span>
      </button>
      <mat-form-field subscriptSizing="dynamic">
        <input type="search" matInput placeholder="{{'SEARCH' | translate}}"
               [(ngModel)]="searchValue"
               (ngModelChange)="onSearchInput()">
        <mat-icon matPrefix>search</mat-icon>
      </mat-form-field>
      <button mat-fab extended="true" [matMenuTriggerFor]="menuSort" #menuTriggerSort="matMenuTrigger"
              [ngClass]="{ 'bottom-radius-0': menuTriggerSort.menuOpen }">
        <mat-icon>sort</mat-icon>
        <span>{{'SORT' | translate}}</span>
      </button>
      <button mat-fab extended="true" [matMenuTriggerFor]="menuFilter" #menuTriggerFilter="matMenuTrigger"
              [ngClass]="{ 'bottom-radius-0': menuTriggerFilter.menuOpen }">
        <mat-icon>tune</mat-icon>
        <span>{{'FILTERS' | translate}}</span>
      </button>
      <span class="example-spacer"></span>
      <mat-button-toggle-group [(ngModel)]="listStyle">
        <mat-button-toggle value="list"><mat-icon>menu</mat-icon></mat-button-toggle>
        <mat-button-toggle value="card"><mat-icon>grid_view</mat-icon></mat-button-toggle>
      </mat-button-toggle-group>
    </mat-toolbar>

    <div style="width: 100%; margin-top: 24px; display: flex; justify-content: center" *ngIf="isTaskListEmpty()">
      <span class="no-task-text">{{'ALL_TASKS_COMPLETED' | translate}}</span>
    </div>
    <div *ngIf="showCards" [ngClass]="listStyle === 'card' ? 'news-toggled-card' : 'news-normal-card'">
      <div *ngFor="let item of sortedAndFilteredNewsData; let isLast = last" class="news-card">
        <app-feed-card-new
          [type]="item.type"
          [status]="item.status"
          [taskStatus]="item.taskStatus? item.taskStatus : null"
          [subject]="item.subject"
          [attachments]="item.attachments"
          [comments]="item.comments"
          [result]="item.result"
          [id]="item.id"
          [referenceNumber]="item.referenceNumber ? item.referenceNumber : ''"
          [taskName]="item.taskName"
          [possibleResults]="item.possibleResults"
          [taskStart]="item.taskStart"
          [taskDeadline]="item.taskDeadline"
          [wfDescription]="item.wfDescription ? item.wfDescription : ''"
          [taskDescription]="item.taskDescription ? item.taskDescription : ''"
          [metaItem]="item.metaItems"
          [mfTorzsOptionList]="requestData.mfMasterOptionList"
          [szotarOptionList]="requestData.szotarOptionList"
          [isFavorite]="item.isFavorite"
          [icon]="item.icon"
          [isLast]="isLast"
          [creator]="item.creator ? item.creator : undefined"
          [taskMetaItems]="item.taskMetaItems ? item.taskMetaItems : undefined"
          [additionalExecutors]="item.additionalExecutors ? item.additionalExecutors : []"
          [templateName]="item.templateName ? item.templateName : undefined"
          [mobileCardView]="listStyle==='card'"
          (openSidenav)="openDetails($event)"
        ></app-feed-card-new>
      </div>
    </div>

    <mat-menu #menuNew="matMenu" xPosition="after" class="mat-menu-background">
      <button mat-menu-item (click)="onNewWfTask()">{{'CREATE_WORKFLOW' | translate}}</button>
      <button mat-menu-item (click)="onNewTask()">{{'CREATE_TASK' | translate}}</button>
    </mat-menu>
    <mat-menu #menuSort="matMenu" xPosition="before" class="mat-menu-background">
      <mat-selection-list multiple="false" [(ngModel)]="sortOrder" hideSingleSelectionIndicator class="compact-sorting-list">
        <ng-container *ngFor="let item of sortOptions; let i = index">
        <mat-list-option [value]="item.code"
                         (click)="changeSortingMethod(item.code)" style="border-radius: 12px">
          <mat-icon [ngClass]="{'visibility-hidden': !item.selected, 'visibility-visible': item.selected}" matListItemIcon>done</mat-icon>
          {{item.displayName | translate}}
        </mat-list-option>
        <mat-divider *ngIf="(i + 1) % 2 === 0 && i !== sortOptions.length - 1"></mat-divider>
        </ng-container>
      </mat-selection-list>
    </mat-menu>
    <mat-menu #menuFilter="matMenu" xPosition="after" class="mat-menu-background">
      <div style="display: flex; flex-direction: column; padding: 0 16px 10px">
        <div *ngFor="let group of filters">
          <div style="width: 100%; min-width: 200px; padding: 10px 0px;">{{ group.name | translate }}</div>
          <mat-radio-group [(ngModel)]="group.selected">
            <mat-radio-button *ngFor="let sub of group.subFilters" value="{{ sub.code }}" [checked]="group.selected == sub.code" (change)="sortAndFilterNewsData()" style="display: block;">{{ sub.name | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </mat-menu>
  </mat-sidenav-content>
</mat-sidenav-container>
